module.exports = __webpack_public_path__ + "fonts/4820cc71945271aefac20dd739e6566b.svg";